import { NoddiTimeRange, NoddiTimeRangeProps } from '@ui-components/Inputs/NoddiTimeRange';
import { useFieldContext } from '../formContext';
import { TanstackFieldError } from '../TanstackFieldError';
import { useTanstackFieldAria } from '../useTanstackFieldAria';

type TimeRange = { start: string | undefined; end: string | undefined };

type Props = Omit<NoddiTimeRangeProps, 'onChange' | 'value'>;

export const TanstackFormTimeRange = (restProps: Props) => {
  const field = useFieldContext<TimeRange>();
  const { start, end } = field.state.value;
  const startAria = useTanstackFieldAria(field, restProps.startAriaDescribedBy);
  const endAria = useTanstackFieldAria(field, restProps.endAriaDescribedBy);

  return (
    <div>
      <NoddiTimeRange
        {...restProps}
        value={{ start: start ?? '', end: end ?? '' }}
        startName={`${field.name}.start`}
        endName={`${field.name}.end`}
        startAriaInvalid={startAria['aria-invalid']}
        endAriaInvalid={endAria['aria-invalid']}
        startAriaDescribedBy={startAria['aria-describedby']}
        endAriaDescribedBy={endAria['aria-describedby']}
        onChange={({ start, end }) => {
          field.handleChange({ start, end });
        }}
      />
      <TanstackFieldError field={field} />
    </div>
  );
};
